import React, { useEffect, useState, createContext } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import SideBar from '../components/Projects/SideBar';
import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';

export const ProjectContext = createContext();

const CreateProjectLayout = () => {
  const { projectId } = useParams();
  const { permissions } = useCurrentUser();
  const canEditProject = permissions.includes('edit_projects');
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projectTrainings, setProjectTrainings] = useState([]);
  const [loadingTrainings, setLoadingTrainings] = useState(true);
  const [trainingsError, setTrainingsError] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(`/projects/${projectId}`);
        setProject(response.data);
      } catch (err) {
        setError('Failed to load project');
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [projectId]);


  const fetchProjectTrainings = async () => {
  if (!projectId) return;
  setLoadingTrainings(true);
  try {
    const response = await axios.get(`/trainings/?project_id=${projectId}`);
    setProjectTrainings(response.data);
  } catch (err) {
    setTrainingsError('Failed to fetch trained models.');
  } finally {
    setLoadingTrainings(false);
  }
  };


  useEffect(() => {
      fetchProjectTrainings();
    }, [projectId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <ProjectContext.Provider
      value={{
        project,
        setProject,
        projectTrainings,
        setProjectTrainings,
        loadingTrainings,
        trainingsError,
        fetchProjectTrainings,
        canEditProject,
      }}
    >
      <div style={{ display: 'flex' }}>
        <SideBar />
        <main style={{ flexGrow: 1, padding: '20px' }}>
          <Outlet />
        </main>
      </div>
    </ProjectContext.Provider>
  );
};

export default CreateProjectLayout;
